/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Actionreachmany2Inputs */

const en_actionreachmany2 = /** @type {(inputs: Actionreachmany2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Goes to ${i?.count} favourites`)
};

const de_actionreachmany2 = /** @type {(inputs: Actionreachmany2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Geht an ${i?.count} Favoriten`)
};

/**
* | output |
* | --- |
* | "Goes to {count} favourites" |
*
* @param {Actionreachmany2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionreachmany2 = /** @type {((inputs: Actionreachmany2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionreachmany2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionreachmany2(inputs)
	return de_actionreachmany2(inputs)
});
export { actionreachmany2 as "actionReachMany" }